"use client";

import React from "react";
import Link from "next/link";
import { NewButton } from "@/components/ui/NewButton";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";

const REGISTER_URL = "https://console.pickcel.com/auth/register";

/** Solution-section CTA — swaps Start Free Trial → Book a Demo on Google Ads sessions. */
export function CorporateSolutionCta() {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <div className="flex justify-center">
        <Link href="/book-a-demo">
          <NewButton variant="primary" size="lg" arrow="grow">
            Book a Demo
          </NewButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Link href={REGISTER_URL} target="_blank" rel="noopener noreferrer">
        <NewButton variant="primary" size="lg" arrow="grow" disclaimer="No credit card required">
          Start Free Trial
        </NewButton>
      </Link>
    </div>
  );
}
